import { Link, useRouter } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { ArrowLeft, Home } from "lucide-react";
import { LanguageSwitcher } from "./LanguageSwitcher";

/**
 * Small nav for public (pre-login) pages: Back (history) + Home (landing) + language toggle.
 * The Back button is only rendered after mount to avoid an SSR/CSR hydration mismatch
 * (window.history is unavailable on the server).
 */
export function PublicNav() {
  const router = useRouter();
  const [canGoBack, setCanGoBack] = useState(false);

  useEffect(() => {
    setCanGoBack(window.history.length > 1);
  }, []);

  return (
    <nav
      aria-label="Utility"
      className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-widest"
    >
      <LanguageSwitcher />
      {canGoBack && (
        <button
          type="button"
          onClick={() => router.history.back()}
          className="inline-flex items-center gap-1.5 rounded-full border border-border px-3 py-1.5 text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Go back"
        >
          <ArrowLeft className="size-3" />
          Back
        </button>
      )}
      <Link
        to="/"
        className="inline-flex items-center gap-1.5 rounded-full border border-border px-3 py-1.5 text-muted-foreground hover:text-foreground transition-colors"
        aria-label="Go to home"
      >
        <Home className="size-3" />
        Home
      </Link>
    </nav>
  );
}
